var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.659766 0.499998H13.2598C14.9931 0.499998 16.6431 0.683331 18.2098 1.05C19.8098 1.38333 21.1931 1.98333 22.3598 2.85C23.5598 3.68333 24.5098 4.8 25.2098 6.2C25.9098 7.56667 26.2598 9.26667 26.2598 11.3C26.2598 13.3 25.8931 15.0167 25.1598 16.45C24.4598 17.8833 23.5098 19.0667 22.3098 20C21.1098 20.9 19.7264 21.5833 18.1598 22.05C16.5931 22.4833 14.9598 22.7 13.2598 22.7H9.25977V33H0.659766V0.499998ZM12.8598 15.9C14.5598 15.9 15.8098 15.5 16.6098 14.7C17.4431 13.9 17.8598 12.7667 17.8598 11.3C17.8598 9.83333 17.4264 8.8 16.5598 8.2C15.6931 7.6 14.4598 7.3 12.8598 7.3H9.25977V15.9H12.8598Z","fill":"#F5F5F5"}));
}

Logo.defaultProps = {"width":"27","height":"33","viewBox":"0 0 27 33","fill":"#ffffff"};

module.exports = Logo;

Logo.default = Logo;
